import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from '../assets/translations/en.json';
import { ELanguages } from '../types/enums/ELanguages';

const availableLanguages = [ELanguages.English];

const resources = {
  [ELanguages.English]: {
    translation: translationEN,
  },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: ELanguages.English,
  debug: true,
  whitelist: availableLanguages,
  react: {
    useSuspense: false,
  },
  lng: ELanguages.English,
});
export default i18n;
